// Formulario de evento: no se envía si los campos de React (precios, horarios) todavía no cargan;
// el servidor recibiría el evento incompleto.
document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-event-form]');
  if (!form) return;

  const ready = form.querySelector('input[name="event[prices]"]') && form.querySelector('input[name="event[schedules]"]');
  if (ready) return;

  event.preventDefault();
  window.alert('El formulario todavía está cargando. Espera unos segundos e inténtalo de nuevo; si no aparece, recarga la página.');
});

// Cambiar el slug cambia la URL pública (/eventos/:public_id/:slug) y la anterior da 404: avisar antes de guardar.
const slugChanged = (input) => input.value.trim() !== input.dataset.originalSlug;

document.addEventListener('input', (event) => {
  const input = event.target.closest('[data-original-slug]');
  if (!input) return;

  const warning = input.closest('div:not(.d-flex)').querySelector('[data-slug-warning]');
  if (warning) warning.hidden = !slugChanged(input);
});

document.addEventListener('submit', (event) => {
  if (event.defaultPrevented) return;

  const input = event.target.closest('[data-event-form]')?.querySelector('[data-original-slug]');
  if (!input || !slugChanged(input)) return;

  const message = 'Vas a cambiar la URL pública del evento.\n\n' +
    'Los links que ya se compartieron (redes, anuncios, mensajes) dejarán de funcionar y darán error 404.\n\n' +
    '¿Guardar de todos modos?';
  if (!window.confirm(message)) event.preventDefault();
});
